import { FC } from "react";
import { Button, ButtonProps, CircularProgress, Tooltip } from "@mui/material";

interface IMyButtonProps extends ButtonProps {
  text?: string;
  isLoading?: boolean;
  tooltip?: string;
  tooltipdDirection?: "n" | "ne" | "e" | "se" | "s" | "sw" | "w" | "nw";
  children?: React.ReactNode;
  variant?: "text" | "outlined" | "contained";
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
}
const Loading = () => {
  return <CircularProgress size={20} />;
};
const MyButton: FC<IMyButtonProps> = (props) => {
  return (
    <>
      {!props.tooltip && (
        <Button
          {...props}
          sx={{ textTransform: "none" }}
          color={props.color ?? "secondary"}
          variant={props.variant ?? "contained"}
          size={props.size ?? "small"}
          startIcon={props.isLoading ? <Loading /> : props.startIcon}
          disabled={props.isLoading || props.disabled}
        >
          {props.text}
          {props.children}
        </Button>
      )}
      {props.tooltip && (
        <Tooltip title={props.tooltip}>
          <Button
            {...props}
            sx={{ textTransform: "none" }}
            color={props.color ?? "secondary"}
            variant={props.variant ?? "contained"}
            size={props.size ?? "small"}
            startIcon={props.isLoading ? <Loading /> : props.startIcon}
            disabled={props.isLoading || props.disabled}
          >
            {props.text}
            {props.children}
          </Button>
        </Tooltip>
      )}
    </>
  );
};

export default MyButton;
